import request from "@/assets/js/request";

/**
 * 判断vde，传入this是为了直接将页面重定向
 * @param data
 * @param $this
 */
export function judgeVde(data,$this){
    request({
        url:'/mobile/judgeVde',
        method:'get',
        params:{vde:data.vde}
    }).then((res)=>{
        if (res.data.code != 1000){
            $this.$router.push({ path: "/404" });
        }
    })
}
